import { render, staticRenderFns } from "./TabComp.vue?vue&type=template&id=fa915776&scoped=true&"
import script from "./TabComp.vue?vue&type=script&lang=js&"
export * from "./TabComp.vue?vue&type=script&lang=js&"
import style0 from "./TabComp.vue?vue&type=style&index=0&id=fa915776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa915776",
  null
  
)

export default component.exports